import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgColumn = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M11 3V15L8.5 16L6 14.5V2.5L8.5 1.5L11 3ZM8.5 4V15L10 14.3506V3.4541L8.5 4Z",
		fill: "black"
	})
});
export default SvgColumn;
